var _style, _g, _radialGradient, _radialGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0_instagram{fill:url(#SVGID_1_instagram);}\r\n\t.st1_instagram{fill:url(#SVGID_00000039831675760166086210000012506043336240511631_);}\r\n\t.st2_instagram{fill:url(#SVGID_00000085953399933115889430000005242002585735599807_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_instagram",
    r: "150%",
    cx: "30%",
    cy: "107%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdf497",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdf497",
    offset: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd5949",
    offset: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6249f",
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285AEB",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0_instagram",
    d: "M26.27,34.54H13.73c-4.57,0-8.28-3.71-8.28-8.28V13.73c0-4.57,3.71-8.28,8.28-8.28h12.53 c4.57,0,8.28,3.71,8.28,8.28v12.53C34.54,30.83,30.83,34.54,26.27,34.54z M13.73,7.95c-3.19,0-5.79,2.6-5.79,5.79v12.53 c0,3.19,2.6,5.79,5.79,5.79h12.53c3.19,0,5.79-2.6,5.79-5.79V13.73c0-3.19-2.6-5.79-5.79-5.79H13.73z"
  }))), /*#__PURE__*/React.createElement("g", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000023253542760613546460000017154607478642425984_instagram",
    r: "150%",
    cx: "30%",
    cy: "107%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdf497",
    offset: 0.00005
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd5949",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6249f",
    offset: 0.8
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023253542760613546460000017154607478642425984_instagram)"
    },
    d: "M20,27.45c-4.11,0-7.45-3.34-7.45-7.45 c0-4.11,3.34-7.45,7.45-7.45s7.45,3.34,7.45,7.45C27.45,24.11,24.11,27.45,20,27.45z M20,15.05c-2.73,0-4.95,2.22-4.95,4.95 s2.22,4.95,4.95,4.95s4.95-2.22,4.95-4.95S22.73,15.05,20,15.05z"
  })), /*#__PURE__*/React.createElement("g", null, _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000115508905206259998890000017333739901883262398_instagram",
    r: "150%",
    cx: "30%",
    cy: "107%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6249f",
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285AEB",
    offset: 0.9
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115508905206259998890000017333739901883262398_instagram)"
    },
    d: "M29.56,12.13 c0,0.99-0.8,1.79-1.79,1.79c-0.99,0-1.79-0.8-1.79-1.79c0-0.99,0.8-1.79,1.79-1.79C28.76,10.34,29.56,11.14,29.56,12.13z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3ab28bb9989bab1a29683cefab96ae25.svg";
export { ForwardRef as ReactComponent };